
import { IconType } from '../../../../../../../../BaseComponents/Icon/Utils/IconDefinitions';
import DataErrorPage from '../../../../../../../../Components/DataErrorPage/DataErrorPage';
import EDButton from '../../../../../../../../BaseComponents/Buttons/Button/EDButton';

interface IProps {
  errorText: string;
  buttonText?: string;
  onButtonClick?: () => void;
  openCreateNew?: () => void;
  testId?: string;
  overrideIconName?: string;
  notFullPage?: boolean;
  errorTextColor?: boolean;
}

/**
 * En vy för när ingen data återfunnits i det nuvarande urvalet
 */
const EkonomiskAnalysDataErrorPage: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    onButtonClick,
    errorText,
    buttonText,
    overrideIconName,
    notFullPage,
    errorTextColor,
  } = props;
  const iconName = (overrideIconName ?? 'ekonomisk_analys') as IconType;

  return (
    <DataErrorPage
      errorText={errorText}
      icon={iconName}
      notFullPage={notFullPage}
      errorTextColor={errorTextColor}
    >
      {props.openCreateNew && (
        <div>
          <EDButton
            label="Skapa ny Analys"
            flat
            primary
            onClick={props.openCreateNew}
          />
        </div>
      )}
      {onButtonClick && buttonText && (
        <EDButton
          label={props.buttonText}
          flat
          primary
          onClick={onButtonClick}
        />
      )}
    </DataErrorPage>
  );
};

export default EkonomiskAnalysDataErrorPage;
